import styled from 'styled-components';

export const FormPanel = styled.div<{ isTablet: boolean }>`
  box-sizing: border-box;
  width: 100%;
  max-width: ${(p) => (p.isTablet ? '100%' : '930px')};
  padding: ${(p) => (p.isTablet ? '30px 15px' : '50px 30px')};
  border-radius: 15px;
  background-color: ${(p) => p.theme.colors.light};
`;

export const SectionTitle = styled.div`
  margin-bottom: 18px;
  font-family: 'Roboto';
  font-weight: 700;
  font-size: ${(p) => p.theme.fontSizes.md};
  color: ${(p) => p.theme.colors.primary500};
`;

export const FormSectionTitle = styled.div`
  margin-bottom: 18px;
  font-family: 'Roboto';
  font-weight: 700;
  font-size: ${(p) => p.theme.fontSizes.base};
  color: ${(p) => p.theme.colors.primary500};
`;

export const FullWidth = styled.div`
  width: 100%;
`;

export const ActionRow = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: ${(p) => (p.isMobile ? 'column' : 'row')};
  gap: 16px;
  margin-top: 36px;
`;

export const HelperText = styled.p`
  margin: 8px 0 0;
  color: ${(p) => p.theme.colors.gray300};
  font-size: ${(p) => p.theme.fontSizes.xs};
`;

export const ValidationText = styled.p`
  margin: 0 0 16px;
  color: ${(p) => p.theme.colors.danger};
  font-size: ${(p) => p.theme.fontSizes.sm};
`;

export const OtpStatusText = styled.p<{ tone: 'info' | 'success' | 'error' }>`
  margin: 8px 0 0;
  color: ${(p) =>
    p.tone === 'success'
      ? p.theme.colors.secondary500
      : p.tone === 'error'
      ? p.theme.colors.danger
      : p.theme.colors.gray400};
  font-size: ${(p) => p.theme.fontSizes.sm};
`;

export const FileBox = styled.div`
  margin-top: 10px;
  padding: 16px;
  border: 1px dashed ${(p) => p.theme.colors.gray200};
  border-radius: ${(p) => p.theme.radii.base};
  color: ${(p) => p.theme.colors.gray400};
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 12px 20px;
  margin-bottom: 22px;

  .label {
    color: ${(p) => p.theme.colors.gray300};
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 6px;
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 10px;
  transform: scale(0.8);
  cursor: pointer;
`;
